import { render, staticRenderFns } from "./TrialConfigViewRefactor.vue?vue&type=template&id=35da11d0&scoped=true&"
import script from "./TrialConfigViewRefactor.vue?vue&type=script&lang=js&"
export * from "./TrialConfigViewRefactor.vue?vue&type=script&lang=js&"
import style0 from "./TrialConfigViewRefactor.vue?vue&type=style&index=0&id=35da11d0&lang=stylus&scoped=true&"
import style1 from "./TrialConfigViewRefactor.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35da11d0",
  null
  
)

export default component.exports